import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=6822a702&scoped=true&"
import script from "./TaskPage.vue?vue&type=script&lang=js&"
export * from "./TaskPage.vue?vue&type=script&lang=js&"
import style0 from "./TaskPage.vue?vue&type=style&index=0&id=6822a702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822a702",
  null
  
)

export default component.exports